import { render } from "./DocuntsDashCard.vue?vue&type=template&id=34847614&scoped=true&ts=true"
import script from "./DocuntsDashCard.vue?vue&type=script&lang=ts"
export * from "./DocuntsDashCard.vue?vue&type=script&lang=ts"

import "./DocuntsDashCard.vue?vue&type=style&index=0&id=34847614&scoped=true&lang=css"
import "./DocuntsDashCard.vue?vue&type=style&index=1&id=34847614&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34847614"]])

export default __exports__